import { render, staticRenderFns } from "./rootcause_report.vue?vue&type=template&id=c88e63b2&scoped=true"
import script from "./rootcause_report.vue?vue&type=script&lang=js"
export * from "./rootcause_report.vue?vue&type=script&lang=js"
import style0 from "./rootcause_report.vue?vue&type=style&index=0&id=c88e63b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88e63b2",
  null
  
)

export default component.exports